import { RiWhatsappFill } from 'react-icons/ri'
import { Outlet } from 'react-router-dom'
import Sidebar from '../components/Sidebar'

const DashboardLayout = () => {
  return (
    <div className='position-relative d-flex h-100vh w-100'>
      <Sidebar />
      <div className='content d-flex flex-column flex-grow-1 p-4 m-0' id='printable-div' style={{ overflowY: 'auto' }}>
        <Outlet />
      </div>

      <div className='position-absolute p-1 rounded-circle bg-white shadow d-print-none' style={{ bottom: 12, right: 12 }}>
        <a
          href='https://api.whatsapp.com/send?phone=+918744923572&lang=eng&text=Hi, Welcome to NEMA AI. Please tell us your query, our customer support team will reach out to you in 24 hours.'
          target='_blank'
        >
          <RiWhatsappFill style={{ width: 36, height: 36, fill: '#25D366' }} />
        </a>
      </div>
    </div>
  )
}
export default DashboardLayout
